import { getEventList } from "api/event";
import BaseTable from "components/DataTable/BaseTable";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateTime, STATES, STATUS_ACTIVE, getStatusFilters } from "utils/helper";

const TABLE_COLUMNS = [
    { id: "name", Header: "Name", accessor: "name", align: "left", sortable: true },
    { id: "start_date", Header: "Start Date", accessor: "start_date", align: "left" },
    { id: "end_date", Header: "End Date", accessor: "end_date", align: "left" },
    { id: "location", Header: "Location", accessor: "location", align: "left", sortable: true },
    { id: "state", Header: "State", accessor: "state", align: "left", sortable: true },
    { id: "ride", Header: "Number of Ride", accessor: "ride", align: "left" },
    { id: "created_at", Header: "Created At", accessor: "created_at", align: "left", sortable: true },
    { id: "status", Header: "Status", accessor: "status", align: "left" },
];

const MONTH_OPTIONS = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
];

const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 2021 + 1 }, (_, i) => ({
        value: currentYear - i,
        label: `${currentYear - i}`,
    }));
};

const EVENT_FILTER_CONFIGS = [
    { id: 'month', label: 'Month', type: 'select', options: MONTH_OPTIONS, placeholder: 'All Months' },
    { id: 'year', label: 'Year', type: 'select', options: getYearOptions(), placeholder: 'All Years' },
    { id: 'state', label: 'State', type: 'select', options: STATES, placeholder: 'All States' },
];

export const parentRoute = '/events';

function EventTable() {
    const navigate = useNavigate();
    const location = useLocation();
    const [refreshKey] = useState(0);
    const savedState = location.state || { sort: "created_at", dir: "desc" };

    const createTableRow = useCallback((item) => ({
        name: <MDTypography component="div" variant="standard" color="text">{item.name}</MDTypography>,
        start_date: <MDTypography component="div" variant="standard" color="text">{new Date(item.start_date).toLocaleDateString()}</MDTypography>,
        end_date: <MDTypography component="div" variant="standard" color="text">{new Date(item.end_date).toLocaleDateString()}</MDTypography>,
        location: <MDTypography component="div" variant="standard" color="text">{item.location}</MDTypography>,
        state: <MDTypography component="div" variant="standard" color="text">{item.state?.name}</MDTypography>,
        ride: <MDTypography component="div" variant="standard" color="text">{item.rides?.length || 0}</MDTypography>,
        created_at: <MDTypography component="div" variant="standard" color="text">{formatDateTime(item.created_at)}</MDTypography>,
        status: <MDTypography component="div" variant="standard" color={item.status?.id === STATUS_ACTIVE ? "success" : "error"}>{item.status?.name}</MDTypography>,
    }), []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <BaseTable
                key={refreshKey}
                queryKey={["events"]}
                title="Events Management"
                columns={TABLE_COLUMNS}
                fetchData={getEventList}
                filterConfigs={EVENT_FILTER_CONFIGS}
                defaultState={savedState}
                createTableRow={createTableRow}
                showAddButton
                addButtonText="Add Event"
                onAddClick={() => navigate(`${parentRoute}/add-event`, { state: savedState })}
                showSearch
                searchPlaceholder="Search event name..."
                showStatusFilter
                onClickRow={(row, key) => { navigate(`${parentRoute}/${row.id}`, { state: savedState }) }}
            />
        </DashboardLayout>
    );
}

export default EventTable;